import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DataService from "../../../../../Service";
import Loader from "../../../../../Components/Loader";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  chipComponent: {
    marginBottom: "20px",
    borderRadius: "5px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& svg": {
      color: "var(--unnamed-color-ffffff)",
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  boxContainer: {
    padding: "0.5rem 2rem 2rem 2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #CECFD0",
    borderRadius: "4px",
  },
  fileUpload: {
    display: "none",
  },
  customFileUpload: {
    padding: "6px 15px",
    fontSize: "0.875rem",
    minWidth: "64px",
    boxSizing: "border-box",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    letterSpacing: "0.02857em",
    textTransform: "uppercase",
    display: "flex",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#EF7000",
    color: "#ffffff",
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    height: "40px",
    fontWeight: 900,
  },
}));

const ProgramDocumentation = (props) => {
  const { currentSelection } = props;
  const classes = useStyles();
  const [acuityFile, setAcuityFile] = useState([]);
  const [organisationFile, setOrganisationFile] = useState([]);
  const [coachFile, setCoachFile] = useState([]);
  const [coacheeFile, setCoacheeFile] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const globaluserData = useSelector((state) => state.commonReducer);
  const currentUserRole = globaluserData?.role;

  // File array state
  const [acuityArray, setAcuityArray] = useState([]);
  const [organisationArray, setOrganisationArray] = useState([]);
  const [coachArray, setCoachArray] = useState([]);
  const [coacheeArray, setCoacheeArray] = useState([]);

  useEffect(() => {
    const acuityData = [];
    acuityFile.map((dd) => {
      Object.values(dd).map((data) => {
        acuityData.push(data);
      });
    });
    setAcuityArray(acuityData);
  }, [acuityFile]);

  useEffect(() => {
    const organisationData = [];
    organisationFile.map((dd) => {
      Object.values(dd).map((data) => {
        organisationData.push(data);
      });
    });
    setOrganisationArray(organisationData);
  }, [organisationFile]);

  useEffect(() => {
    const coachData = [];
    coachFile.map((dd) => {
      Object.values(dd).map((data) => {
        coachData.push(data);
      });
    });
    setCoachArray(coachData);
  }, [coachFile]);

  useEffect(() => {
    const coacheeData = [];
    coacheeFile.map((dd) => {
      Object.values(dd).map((data) => {
        coacheeData.push(data);
      });
    });
    setCoacheeArray(coacheeData);
  }, [coacheeFile]);

  useEffect(() => {
    props?.setStepperData("Program documentation");
    props?.setHeaderType("");
    fetchDocumentation();
  }, []);

  const fetchDocumentation = () => {
    setLoading(true);
    if (props?.action == "editMaster") {
      DataService.getData(
        { master_template_id: currentSelection?.id },
        "uploaded_document"
      )
        .then((res) => {
          if (res?.success) {
            setData(res);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      DataService.getData(
        { programme_id: currentSelection?.id },
        "program_documents"
      )
        .then((res) => {
          if (res?.success) {
            setData(res);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    Object.values(acuityArray).map((data) => {
      formData.append("acuity_admin_documents[]", data);
    });

    Object.values(organisationArray).map((data) => {
      formData.append("organisation_documents[]", data);
    });

    Object.values(coachArray).map((data) => {
      formData.append("coach_documents[]", data);
    });

    Object.values(coacheeArray).map((data) => {
      formData.append("coachee_documents[]", data);
    });

    setNextButtonLoading(true);
    if (props?.action == "editMaster") {
      formData.append("master_template_id", currentSelection?.id);
      DataService.createData(formData, "upload_program_documents")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            fetchDocumentation();
            props?.onNextClick();
          }
        })
        .catch(() => {
          setNextButtonLoading(false);
        });
    } else {
      formData.append("programme_id", currentSelection?.id);
      DataService.createData(formData, "program_documents")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            fetchDocumentation();
            props?.onNextClick();
          }
        })
        .catch(() => {
          setNextButtonLoading(false);
        });
    }
  };

  const handleDelete = (id) => {
    setDeleteLoading(true);
    if (props?.action == "editMaster") {
      DataService.deleteDirectFeild(
        `/master_templates/delete_pgm_document?master_template_id=${currentSelection?.id}&document_id=${id}`
      )
        .then((res) => {
          if (res?.success) {
            setDeleteLoading(false);
            fetchDocumentation();
          }
        })
        .catch((error) => {
          setDeleteLoading(false);
        });
    } else {
      DataService.deleteDirectFeild(
        `programmes/delete_pgm_document?programme_id=${currentSelection?.id}&document_id=${id}`
      )
        .then((res) => {
          if (res?.success) {
            setDeleteLoading(false);
            fetchDocumentation();
          }
        })
        .catch((error) => {
          setDeleteLoading(false);
        });
    }
  };

  const handleDeleteStaticFile = (itemIndex, fileName) => {
    if (fileName == "acuityFile") {
      const filteredData = Object.values(acuityArray).filter((data, index) => {
        return index !== itemIndex;
      });
      setAcuityArray(filteredData);
    } else if (fileName == "organisationFile") {
      const filteredData = Object.values(organisationArray).filter(
        (data, index) => {
          return index !== itemIndex;
        }
      );
      setOrganisationArray(filteredData);
    } else if (fileName == "coachFile") {
      const filteredData = Object.values(coachArray).filter((data, index) => {
        return index !== itemIndex;
      });
      setCoachFile(filteredData);
    } else if (fileName == "coacheeFile") {
      const filteredData = Object.values(coacheeArray).filter((data, index) => {
        return index !== itemIndex;
      });
      setCoacheeArray(filteredData);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Container maxWidth="xl">
          {loading || (deleteLoading && <Loader />)}
          <Grid>
            <Grid
              container
              spacing={5}
              direction="row"
              alignItems="center"
              justify="flex-start"
              style={{ padding: "3rem 40px" }}
            >
              <Grid item xs={3}>
                <div className={classes.boxContainer}>
                  <Typography
                    variant="h2"
                    style={{ padding: "2rem 1rem", fontWeight: "bold" }}
                  >
                    Acuity admin
                  </Typography>
                  <label
                    htmlFor="acuity_admin_documents[]"
                    className={classes.customFileUpload}
                  >
                    <CloudUploadIcon /> &nbsp; Upload
                  </label>
                  <input
                    id={"acuity_admin_documents[]"}
                    multiple={currentUserRole == "admin" ? true : false}
                    type="file"
                    accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
                    className={classes.fileUpload}
                    onChange={(event) => {
                      if (Object.values(event.target.files).length) {
                        let inValidFile = 0;
                        Object.values(event.target.files).map(
                          (imageFile, index) => {
                            if (
                              !imageFile.name.match(
                                /\.(jpg|jpeg|png|doc|docx|pdf)$/
                              )
                            ) {
                              inValidFile += 1;
                            }
                          }
                        );
                        !inValidFile &&
                          setAcuityFile((prev) => [
                            ...prev,
                            event.target.files,
                          ]);
                        inValidFile && alert("Invalid File uploaded");
                      }
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.boxContainer}>
                  <Typography
                    variant="h2"
                    style={{ padding: "2rem 1rem", fontWeight: "bold" }}
                  >
                    Organization
                  </Typography>
                  <label
                    htmlFor="organisation_documents[]"
                    className={classes.customFileUpload}
                  >
                    <CloudUploadIcon /> &nbsp; Upload
                  </label>
                  <input
                    id={"organisation_documents[]"}
                    multiple={currentUserRole == "admin" ? true : false}
                    type="file"
                    accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
                    className={classes.fileUpload}
                    onChange={(event) => {
                      if (Object.values(event.target.files).length) {
                        let inValidFile = 0;
                        Object.values(event.target.files).map(
                          (imageFile, index) => {
                            if (
                              !imageFile.name.match(
                                /\.(jpg|jpeg|png|doc|docx|pdf)$/
                              )
                            ) {
                              inValidFile += 1;
                            }
                          }
                        );
                        !inValidFile &&
                          setOrganisationFile((prev) => [
                            ...prev,
                            event.target.files,
                          ]);
                        inValidFile && alert("Invalid File uploaded");
                      }
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.boxContainer}>
                  <Typography
                    variant="h2"
                    style={{ padding: "2rem 1rem", fontWeight: "bold" }}
                  >
                    Coach
                  </Typography>
                  <label
                    htmlFor="coach_documents[]"
                    className={classes.customFileUpload}
                  >
                    <CloudUploadIcon /> &nbsp; Upload
                  </label>
                  <input
                    id={"coach_documents[]"}
                    multiple={currentUserRole == "admin" ? true : false}
                    type="file"
                    accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
                    className={classes.fileUpload}
                    onChange={(event) => {
                      if (Object.values(event.target.files).length) {
                        let inValidFile = 0;
                        Object.values(event.target.files).map(
                          (imageFile, index) => {
                            if (
                              !imageFile.name.match(
                                /\.(jpg|jpeg|png|doc|docx|pdf)$/
                              )
                            ) {
                              inValidFile += 1;
                            }
                          }
                        );
                        !inValidFile &&
                          setCoachFile((prev) => [...prev, event.target.files]);
                        inValidFile && alert("Invalid File uploaded");
                      }
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={3}>
                <div className={classes.boxContainer}>
                  <Typography
                    variant="h2"
                    style={{ padding: "2rem 1rem", fontWeight: "bold" }}
                  >
                    Coachee
                  </Typography>
                  <label
                    htmlFor="coachee_documents[]"
                    className={classes.customFileUpload}
                  >
                    <CloudUploadIcon /> &nbsp; Upload
                  </label>
                  <input
                    id={"coachee_documents[]"}
                    multiple={currentUserRole == "admin" ? true : false}
                    type="file"
                    accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
                    className={classes.fileUpload}
                    onChange={(event) => {
                      if (Object.values(event.target.files).length) {
                        let inValidFile = 0;
                        Object.values(event.target.files).map(
                          (imageFile, index) => {
                            if (
                              !imageFile.name.match(
                                /\.(jpg|jpeg|png|doc|docx|pdf)$/
                              )
                            ) {
                              inValidFile += 1;
                            }
                          }
                        );
                        !inValidFile &&
                          setCoacheeFile((prev) => [
                            ...prev,
                            event.target.files,
                          ]);
                        inValidFile && alert("Invalid File uploaded");
                      }
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid style={{ padding: "0px 0px 0px 50px" }} container spacing={2}>
              {Array.from(acuityArray).length > 0 ||
              Array.from(organisationArray).length > 0 ||
              Array.from(coachArray).length > 0 ||
              Array.from(coacheeArray).length > 0 ? (
                <h3>New documents</h3>
              ) : (
                <></>
              )}
            </Grid>
            <Grid
              container
              spacing={5}
              direction="row"
              alignItems="flex-start"
              justify="flex-start"
              style={{ padding: "0px 40px", position: "relative" }}
            >
              <Grid item xs={3}>
                {Object.values(acuityArray)?.map((data, index) => {
                  if (data?.name) {
                    return (
                      <Chip
                        className={classes.chipComponent}
                        label={data.name.replace(/^.*[\\\/]/, "").split("?")[0]}
                        onDelete={() => {
                          handleDeleteStaticFile(index, "acuityFile");
                        }}
                        variant="outlined"
                      />
                    );
                  }
                })}
              </Grid>

              <Grid item xs={3}>
                {Object.values(organisationArray)?.map((data, index) => {
                  if (data?.name) {
                    return (
                      <Chip
                        className={classes.chipComponent}
                        label={data.name.replace(/^.*[\\\/]/, "").split("?")[0]}
                        onDelete={() => {
                          handleDeleteStaticFile(index, "organisationFile");
                        }}
                        variant="outlined"
                      />
                    );
                  }
                })}
              </Grid>

              <Grid item xs={3}>
                {Object.values(coachArray)?.map((data, index) => {
                  if (data?.name) {
                    return (
                      <Chip
                        className={classes.chipComponent}
                        label={data.name.replace(/^.*[\\\/]/, "").split("?")[0]}
                        onDelete={() => {
                          handleDeleteStaticFile(index, "coachFile");
                        }}
                        variant="outlined"
                      />
                    );
                  }
                })}
              </Grid>

              <Grid item xs={3}>
                {Object.values(coacheeArray)?.map((data, index) => {
                  if (data?.name) {
                    return (
                      <Chip
                        className={classes.chipComponent}
                        label={data.name.replace(/^.*[\\\/]/, "").split("?")[0]}
                        onDelete={() => {
                          handleDeleteStaticFile(index, "coacheeFile");
                        }}
                        variant="outlined"
                      />
                    );
                  }
                })}
              </Grid>
            </Grid>
            <Grid style={{ padding: "0px 0px 0px 50px" }} container spacing={2}>
              {data?.acuity_admin_documents?.length > 0 ||
              data?.coach_documents?.length > 0 ||
              data?.coachee_documents?.length > 0 ||
              data?.organisation_documents?.length > 0 ? (
                <h3>Uploaded documents</h3>
              ) : (
                <></>
              )}
            </Grid>
            <Grid
              container
              spacing={5}
              direction="row"
              alignItems="flex-start"
              justify="flex-start"
              style={{ padding: "0px 40px", position: "relative" }}
            >
              <Grid item xs={3}>
                {data?.acuity_admin_documents
                  ?.sort((a, b) => {
                    return b.id - a.id;
                  })
                  ?.map((data) => {
                    if (data?.url) {
                      return (
                        <Chip
                          onClick={() => window.open(data?.url, "_blank")}
                          className={classes.chipComponent}
                          label={
                            data?.url.replace(/^.*[\\\/]/, "").split("?")[0]
                          }
                          onDelete={() => {
                            handleDelete(data?.id);
                          }}
                          variant="outlined"
                        />
                      );
                    }
                  })}
              </Grid>

              <Grid item xs={3}>
                {data?.organisation_documents
                  ?.sort((a, b) => {
                    return b.id - a.id;
                  })
                  ?.map((data) => {
                    if (data?.url) {
                      return (
                        <Chip
                          onClick={() => window.open(data?.url, "_blank")}
                          className={classes.chipComponent}
                          label={
                            data?.url.replace(/^.*[\\\/]/, "").split("?")[0]
                          }
                          onDelete={() => {
                            handleDelete(data?.id);
                          }}
                          variant="outlined"
                        />
                      );
                    }
                  })}
              </Grid>

              <Grid item xs={3}>
                {data?.coach_documents
                  ?.sort((a, b) => {
                    return b.id - a.id;
                  })
                  ?.map((data) => {
                    if (data?.url) {
                      return (
                        <Chip
                          onClick={() => window.open(data?.url, "_blank")}
                          className={classes.chipComponent}
                          label={
                            data?.url.replace(/^.*[\\\/]/, "").split("?")[0]
                          }
                          onDelete={() => {
                            handleDelete(data?.id);
                          }}
                          variant="outlined"
                        />
                      );
                    }
                  })}
              </Grid>

              <Grid item xs={3}>
                {data?.coachee_documents
                  ?.sort((a, b) => {
                    return b.id - a.id;
                  })
                  ?.map((data) => {
                    if (data?.url) {
                      return (
                        <Chip
                          onClick={() => window.open(data?.url, "_blank")}
                          className={classes.chipComponent}
                          label={
                            data?.url.replace(/^.*[\\\/]/, "").split("?")[0]
                          }
                          onDelete={() => {
                            handleDelete(data?.id);
                          }}
                          variant="outlined"
                        />
                      );
                    }
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            type="submit"
            disabled={nextButtonLoading}
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </>
  );
};

export default ProgramDocumentation;
